import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=0890996a&scoped=true&"
import script from "./registry.ts?vue&type=script&lang=ts&"
export * from "./registry.ts?vue&type=script&lang=ts&"
import style0 from "./registry.scss?vue&type=style&index=0&id=0890996a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890996a",
  null
  
)

export default component.exports